import type { MenuProps } from 'antd';

import { Menu } from '../Menu/Menu';
import { useGlobal } from 'src/contexts/GlobalContext/GlobalContext';

interface SidebarProps {
  onClick?: MenuProps['onClick'];
  onClickLogo?: () => void;
}

export const SidebarDesktop = (props: SidebarProps) => {
  const { onClick, onClickLogo } = props;
  const { isSidebarCollapsed, setIsSidebarCollapsed } = useGlobal();

  const toggleCollapsed = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  return (
    <Menu
      data-testid="sidebar-desktop"
      collapsed={isSidebarCollapsed}
      onClick={onClick}
      onClickLogo={onClickLogo}
      toggleCollapsed={toggleCollapsed}
    />
  );
};
